"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.carry = carry;
exports.clamp = clamp;
exports.mod = mod;
exports.wrap = wrap;
exports.isInside = isInside;
/**
 * Determine the carry of x given a range.
 * @example
 * carry(11, 0, 9); // => 1
 * @example
 * carry(-1, 0, 9); // => -1
 * @param {number} x The number to find the carry of.
 * @param {number} lo The low end of the range.
 * @param {number} hi The high end of the range.
 * @returns {number} The carry of x.
 */

function carry(x, lo, hi) {
  return Math.floor((x - lo) / (hi - lo));
}
/**
 * Clamp x to a range.
 * @example
 * carry(3, 5, 9); // => 5
 * @example
 * carry(7, 5, 9); // => 7
 * @example
 * carry(11, 5, 9); // => 9
 * @param {number} x The number to clamp to a range.
 * @param {number} lo The low end of the range.
 * @param {number} hi The high end of the range.
 * @returns {number} The result of clamping x to a range.
 */


function clamp(x, lo, hi) {
  return Math.min(Math.max(x, lo), hi);
}
/**
 * Implements a version of mod() that doesn't return negative numbers.
 * @param {number} n The dividend.
 * @param {number} m The divisor.
 * @returns {number} The result of n mod m, where the result is not negative.
 */


function mod(n, m) {
  return (n % m + m) % m;
}
/**
 * Wrap x around a given range.
 * @example
 * wrap(7, 0, 5); // => 2
 * @example
 * wrap(-2, 0, 5); // => 3
 * @param {number} x The number to wrap around the range.
 * @param {number} lo The low end of the range.
 * @param {number} hi The high end of the range.
 * @returns {number} The result of wrapping x around a range.
 */


function wrap(x, lo, hi) {
  return mod(x - lo, hi - lo) + lo;
}
/**
 * Determine if x is inside of range, excluding the bounds of the range.
 * @param {number} x The number to query the range with.
 * @param {number} lo The low end of the range.
 * @param {number} hi The high end of the range.
 * @param {boolean}
 */


function isInside(x, lo, hi) {
  return x > lo && x < hi;
}